import type { FC } from "react";

import { translate } from "app/filters/i18nFilter";
import type { IFilterViewBaseModelProps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filterInstance";
import { TextField } from "app/pages/sales-intelligence/modules/find-apps-filters/components/filters/AppsIdentifiersFilter/components/TextField/TextField";
import { StyledFilterHeading } from "app/pages/sales-intelligence/modules/find-apps-filters/components/filters/AppsIdentifiersFilter/styles";
import { AppsIdentifiers } from "app/pages/sales-intelligence/modules/find-apps-filters/components/filters/AppsIdentifiersFilter/types";
import { parseInputValue } from "app/pages/sales-intelligence/modules/find-apps-filters/components/filters/AppsIdentifiersFilter/utils";
import type { IAppsAndroidIdentifierFilter } from "app/pages/sales-intelligence/store/find-apps/types";

import AppIdentifierBulkAdd from "../components/AppIdentifierBulkAdd/AppIdentifierBulkAdd";

import { StyledAndroidIdentifiersFilter } from "./styles";

export const AppsAndroidIdentifiersFilter: FC<IFilterViewBaseModelProps<IAppsAndroidIdentifierFilter>> = ({
    onFilterUpdate,
    value,
}) => {
    const handleUpdate = (newValue: string[]) => {
        onFilterUpdate({ packageNames: Array.from(new Set([...(value?.packageNames ?? []), ...newValue])) });
    };

    const handleTextFieldUpdate = (newValue: string) => {
        handleUpdate(parseInputValue(newValue));
    };

    const validate = (inputValue: string) => {
        const regExp = /^[a-z]([a-z0-9_]*\.)+[a-z0-9_]+$/;
        return parseInputValue(inputValue).every((v) => regExp.test(v));
    };

    return (
        <StyledAndroidIdentifiersFilter>
            <StyledFilterHeading>{translate("si.find_apps.filters.identifier.android.title")}</StyledFilterHeading>
            <TextField
                onUpdate={handleTextFieldUpdate}
                placeholder={translate("si.find_apps.filters.identifier.android.placeholder")}
                label={translate("si.find_apps.filters.identifier.android.label")}
                validate={validate}
            />
            <AppIdentifierBulkAdd
                onUpdate={handleUpdate}
                appIdentifierType={AppsIdentifiers.PackageName}
            />
        </StyledAndroidIdentifiersFilter>
    );
};
